import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";  
import { Toast } from '../components_root/ToastContext.jsx';
import { MdCalculate, MdCall, MdCode, MdEditDocument, MdFace, MdKey, MdKeyboard, MdLocationCity, MdOutlinePhoneAndroid, MdPhoneAndroid, MdPictureAsPdf, MdQrCode } from "react-icons/md";

import { Create_services } from '../services_root/create_services.js';
import { Randomcode } from '../components_root/rendom_code.js';
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Website_data() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [websitedata, setwebsitedata] = useState([]);
    const [servicesdata, setServicesdata] = useState([]);
    const [serviceId, setServiceId] = useState(null);
const select_company_uid = Cookies.get("select_company_uid");
    useEffect(() => {
        const website_uid = Cookies.get("website_uid"); 
        const fetchCompany = async () => {
            const docRef = doc(db, "websiteservicesdb", select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const websitedata = {
                    id: docSnap.id,
                    ...docSnap.data(),
                };

                setwebsitedata([websitedata]); // store as array for map()
            } else {
                setwebsitedata([]);
            }
        };

        fetchCompany();
    }, []);

    // useEffect(() => {
    //     const fetchVoucher = async () => {
    //         const select_company_uid = Cookies.get("select_company_uid");
    //         if (!select_company_uid) return;

    //         // Get only THIS service by ID
    //         const docRef = doc(db, "servicesdb", "nHjKn3hpo5HL5fAcw9JI");
    //         const docSnap = await getDoc(docRef);

    //         if (!docSnap.exists()) return;

    //         const serviceId = docSnap.id;
    //         const serviceData = docSnap.data();

    //         // Match with company-specific services
    //         const q = query(
    //             collection(db, "companies", select_company_uid, "accounting"),
    //             where("suid", "==", serviceId)
    //         );

    //         const companySnap = await getDocs(q);

    //         const companyServices = companySnap.docs.map(c => ({
    //             id: c.id,
    //             ...c.data()
    //         }));

    //         // Set final data format expected by your UI
    //         setServicesdata([
    //             {
    //                 id: serviceId,
    //                 ...serviceData,
    //                 companyServices: companyServices
    //             }
    //         ]);
    //     };

    //     fetchVoucher();
    // }, []);

    const Create_services_handle = async () => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return; 
        const servicetablename = "accountingfinancedb";
        const data = {
            servicetablename, 
            ...servicesdata[0], 
        };

        const result = await Create_services(data);
        if (result.success) {
            navigate(`/${servicesdata[0].slug}`);
            Toastshow("Service created successfully");
        } else {
            Toastshow(`Error: ${result.error}`);
        }
    };

    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>
 
            <div className="container_roots">
           <div className="container_roots">
    {websitedata.map((row) => (
        <div className="b-bottom" key={row.id}>
            <table>
                <tbody>
                    <tr>
                        <td width={110}>
                            <img
                                src={row?.logo_url}
                                className="service_photo"
                            />
                        </td>

                        <td>
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-h1 fcap bold text-pre">
                                                {row.name}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className="text-h2 bold cap text-pre test-off">
                                                {row.brandname || "N/A"}
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <div className="text-h2 text-pre test-off">
                                                {row.domain_registration || "No domain registered"}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    ))}
</div>

            </div >



        </div >
    );
}
